import { TweenMax } from "gsap"

const LOADING_SELECTOR: string = '[data-loading]';

export class LoadingUI {
  private elements;
  
  public constructor(public base: HTMLElement) {}

  public animate() {
    this.elements = {
      ghost: TweenMax.to("#ghost", {
        y: 7,
        repeat: -1,
        duration: .7,
        repeatDelay: 0.5,
        yoyo: true,
        css: {
          opacity: .1
        },
      }),
      oval: TweenMax.to("#oval", {
        repeat: -1,
        duration: 0.5,
        delay: 4,
        yoyo: true,
        scale: 1.2,
        transformOrigin: 'center',
        yoyoEase: 'power2.in',
      }),
      cross: TweenMax.to("#cross", {
        repeat: -1,
        rotation: 360,
        duration: 2,
        transformOrigin: 'center',
        yoyo: true,
        yoyoEase: 'power2.in',
      }),
      gamepad: TweenMax.to("#gamepad", {
        y: 7,
        repeat: -1,
        duration: .7,
        yoyo: true
      }),
      plus: TweenMax.to('#plus', {
        repeat: -1,
        transformOrigin: 'center',
        css: {
          opacity: .6
        },
        yoyo: true,
        yoyoEase: 'power2.in',
      }),
      lightning: TweenMax.to('#lightning', {
        repeat: -1,
        x: -3,
        duration: .5,
        yoyo: true,
        yoyoEase: 'power2.in',
      })
    }
  
  }
}

export function createLoaderInstances() : LoadingUI[] {
  let instances: LoadingUI[] = [];
  document.querySelectorAll(LOADING_SELECTOR).forEach((item) => {
    const el = item as HTMLElement;
    instances.push(new LoadingUI(el));
  });

  return instances;
}
